import classNames from 'classnames';
import I18n from 'i18n-js';
import { bool, string } from 'prop-types';

import styles from './Body.module.scss';

export default function Body({
  secondaryPopup,
  summaryActive,
  subscriptionValidUntil,
}) {
  return (
    <div className={styles.body}>
      {!secondaryPopup && (
        <div
          className={classNames(
            styles.cancelSubscriptionPopup,
            styles.cancelSubscriptionConfirmation,
            { [styles.summaryActive]: summaryActive },
          )}
        >
          <span className={classNames(styles.text, styles.title)}>
            {I18n.t('season_ticket_popup_cancel_headline')}
          </span>
          <p className={classNames(styles.text, styles.para)}>
            {I18n.t('season_ticket_popup_cancel_description')}
          </p>
        </div>
      )}
      <div
        className={classNames(styles.cancelSubscriptionPopup, {
          [styles.mobileHidden]: !secondaryPopup,
          [styles.summaryActive]: summaryActive,
        })}
      >
        <span className={classNames(styles.text, styles.title)}>
          {I18n.t('season_ticket_popup_confirmc_headline')}
        </span>
        <p className={classNames(styles.text, styles.para)}>
          {I18n.t('season_ticket_popup_confirmc_description')}
        </p>
        <p className={styles.highlightedPara}>{subscriptionValidUntil}</p>
      </div>
    </div>
  );
}

Body.propTypes = {
  secondaryPopup: bool,
  summaryActive: bool,
  subscriptionValidUntil: string,
};
